import Utils from "@/utils/Utils";

export default {

    basicValidation(validation = {}, form = {}){
        validation.erros = false;
        Object.keys(validation).forEach(key => {
            if(Utils.isEmptyNullOrUndefined(form[key]) && key !== 'erros'){
                validation[key] = true;
                validation.erros = true;
            } else if(key !== 'erros') {
                validation[key] = false;
            }
        });
        return validation;
    }

}
